import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import {
  MatCardModule,
  MatFormFieldModule,
  MatSelectModule,
  MatOptionModule,
  MatSlideToggleModule,
  MatTableModule,
  MatInputModule,
  MatIconModule,
  MatButtonModule,
  MatSnackBarModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatDividerModule,
  MatGridListModule,
  MatListModule,
  MatPaginatorModule,
  MatTooltipModule,
  MatStepperModule,
  MatToolbarModule,
  MatDialogModule,
  MatProgressSpinnerModule,
  MatTabsModule,
  MatRadioModule,
  MatExpansionModule,
  MatSortModule,
  MatTreeModule,
  MatButtonToggleModule,
  MatMenuModule,
  MatSliderModule,
  MatBadgeModule,
} from "@angular/material";
import { MatAutocompleteModule } from "@angular/material/autocomplete";

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    MatTableModule,
    MatInputModule,
    MatSlideToggleModule,
    MatIconModule,
    MatButtonModule,
    MatSnackBarModule,
    MatCheckboxModule,
    MatSortModule,
    MatChipsModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDividerModule,
    MatGridListModule,
    MatListModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatStepperModule,
    MatToolbarModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatTabsModule,
    MatRadioModule,
    MatExpansionModule,
    MatTreeModule,
    MatButtonToggleModule,
    MatSliderModule,
    MatAutocompleteModule,
    MatMenuModule,
    MatBadgeModule,
  ],
  exports: [
    MatCardModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    MatTableModule,
    MatInputModule,
    MatSlideToggleModule,
    MatIconModule,
    MatButtonModule,
    MatSnackBarModule,
    MatCheckboxModule,
    MatSortModule,
    MatChipsModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDividerModule,
    MatGridListModule,
    MatListModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatStepperModule,
    MatToolbarModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatSliderModule,
    MatTabsModule,
    MatRadioModule,
    MatExpansionModule,
    MatTreeModule,
    MatButtonToggleModule,
    MatAutocompleteModule,
    MatMenuModule,
    MatBadgeModule,
  ],
  declarations: [],
})
export class MaterialModule {}
